<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 *ngIf="currentMode === salaryMode.CREATE" class="mb-1">
        {{ employeeName }}'s
        <!-- {{ user?.role === 'Contractor' ? 'PayOut' : 'Salary' }} -->
        {{ isContractor(user) === true ? 'PayOut' : 'Salary' }}
      </h2>
      <h2
        *ngIf="currentMode === salaryMode.REVISE || currentMode === salaryMode.UPDATE"
        class="mb-1"
      >
        {{ currentMode === salaryMode.REVISE ? 'Revise' : 'Update' }} {{ employeeName }}'s
        <!-- {{ user?.role === 'Contractor' ? 'PayOut' : 'Salary' }} -->
        {{ isContractor(user) === true ? 'PayOut' : 'Salary' }}
        {{
          currentScreenIndex > 1
            ? ' Effective From ' + ((ctc$ | async)?.effectiveFrom | date: 'MMM-dd-yyyy')
            : ''
        }}
      </h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">
            <!-- {{ user?.role === 'Contractor' ? 'Contractor' : 'Employee' }} -->
            {{ isContractor(user) === true ? 'Contractor' : 'Employee' }}
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <!-- {{ user?.role === 'Contractor' ? 'PayOut' : 'Salary' }} -->
            {{ isContractor(user) === true ? 'PayOut' : 'Salary' }}
          </li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2">
      <a
        href="javascript:void(0);"
        class=""
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-original-title="Collapse"
        id="collapse-header"
      >
        <i class="ti ti-chevrons-up"></i>
      </a>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <!-- <ul class="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
      <li *ngFor="let tab of tabs" class="nav-item">
        <a
          [ngClass]="{ 'nav-link': true, active: activeChild === tab }"
          (click)="renderChild(tab)"
          *appHasPermission="'view_' + tab.toLowerCase()"
          ><i class="ti ti-settings me-2"></i>{{ tab }}</a
        >
      </li>
    </ul> -->
  <div [ngSwitch]="currentScreenIndex">
    <ng-container *ngSwitchCase="screens[0]">
      <app-statutory-compliances></app-statutory-compliances>
    </ng-container>
    <ng-container *ngSwitchCase="screens[1]">
      <app-ctc
        *ngIf="currentMode === salaryMode.CREATE"
        (formValuesChanged)="onformValuesChanged($event)"
      ></app-ctc>
      <app-ctc-revision
        *ngIf="currentMode === salaryMode.REVISE || currentMode === salaryMode.UPDATE"
        (formValuesChanged)="onformValuesChanged($event)"
      ></app-ctc-revision>
    </ng-container>
    <ng-container *ngSwitchCase="screens[2]">
      <app-salary-data></app-salary-data>
    </ng-container>
    <ng-container *ngSwitchCase="screens[3]">
      <app-salary-summary
        *ngIf="currentMode === salaryMode.CREATE"
        (screenNumber)="resetScreen($event)"
      ></app-salary-summary>
      <app-revised-salary-summary
        *ngIf="currentMode === salaryMode.REVISE || currentMode === salaryMode.UPDATE"
        (saveButtonState)="setNextButtonState($event)"
      ></app-revised-salary-summary>
    </ng-container>
  </div>
  <div>
    <div class="col-xl-9 d-flex justify-content-center">
      <button class="btn btn-light" (click)="previousScreen()">
        {{ currentScreenIndex === 0 ? 'Cancel' : 'Previous' }}
      </button>
      <button class="btn btn-primary" (click)="nextScreen()" [disabled]="nextButtonState">
        {{ currentScreenIndex === screens.length - 1 ? 'Save' : 'Next' }}
      </button>
      <button
        *ngIf="currentScreenIndex === 3 && isContractor(user)"
        (click)="openModal(MonthlySalaryModalComponent)"
        class="btn btn-info ms-2"
        type="button"
      >
        Preview Monthly Salary
      </button>
    </div>
    <div class="col-xl-3 theiaStickySidebar"></div>
  </div>
</div>
